/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/4/2023
 */

import { Delete, Edit, ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  ButtonGroup,
  Collapse,
  Container,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useGetAllCatWithSubCatQuery } from "../../Store/Services/CategoryService";
import {
  openDeleteCategoryModal,
  openEditCategoryModal,
} from "../../Store/Slices/categorySlice";

import styles from "./NestedTable.module.css";
const NestedTable = () => {
  const { data: categories, isSuccess } = useGetAllCatWithSubCatQuery();

  // Check if the data retrieval was successful and categories data exists
  if (!isSuccess || !categories || !Array.isArray(categories.list)) {
    return <div>Loading...</div>; // Handle loading state or error state
  }

  return (
    <Container>
      <TableContainer>
        <Table className={styles.tableContainer} size="small">
          <TableBody>
            {categories.list.map((cat) => (
              <RenderCategory key={cat.catId} category={cat} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

const RenderCategory = ({ category }) => {
  const [expand, setExpand] = useState(false);
  const dispatch = useDispatch();

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton onClick={() => setExpand(!expand)}>
            {expand ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
          {category.catDisplayName}
        </TableCell>
        <TableCell>
          <ButtonGroup>
            <IconButton
              onClick={() => {
                dispatch(openEditCategoryModal(category.catId));
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={() => {
                dispatch(openDeleteCategoryModal(category.catId));
              }}
            >
              <Delete />
            </IconButton>
          </ButtonGroup>
        </TableCell>
      </TableRow>
      <Collapse in={expand} timeout="auto" unmountOnExit>
        {category.subCategoryList &&
          category.subCategoryList.map((subCat) => (
            <RenderCategory key={subCat.catId} category={subCat} />
          ))}
      </Collapse>
    </>
  );
};

export default NestedTable;
